import { mainNav } from "@/config/routes";

export const site = {
  name: "Swargaseema",
  phone: "91801 23456",
  email: "info@swargaseema.com",
  address:
    "Unit No: S-7, Second Floor, Fantasy Square Complex, Opp. Bio Diversity Park, Gachibowli, Hyderabad, Telangana 500032",
  nav: mainNav
};

